@if (chapter) {
    <div>
        <app-main-chapter-heading [chapter]="chapter"></app-main-chapter-heading>
        @if (pagePreviews) {
            <sidebar-single-chapter-page [previewPages]="pagePreviews"></sidebar-single-chapter-page>
        }
    </div>
}
